import { useSettings } from "@/context/SettingsContext";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Heart, Sparkles, Leaf } from "lucide-react";

export default function About() {
  const { settings } = useSettings();
  return (
    <div className="animate-fade-in">
      <div className="bg-brand-gold-light/40 py-14">
        <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
          <p className="font-accent text-2xl text-brand">Our Story</p>
          <h1 className="mt-2 font-heading text-4xl text-brand-dark sm:text-5xl">
            Made in a home kitchen, shared with love
          </h1>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-14 text-center sm:px-6 lg:px-8">
        <p className="text-lg leading-relaxed text-brand-muted">
          {settings.business_name || "Taanya Homefoods"} began with a simple belief — that the best food is made at home,
          in small batches, with real ingredients and a whole lot of love. What started as treats for family and
          friends has grown into a little kitchen brand trusted by many.
        </p>
        <p className="mt-5 text-lg leading-relaxed text-brand-muted">
          From rich customised chocolates and fudgy brownies to wholesome laddus and authentic pickles, every product is
          handcrafted fresh to order. No preservatives, no shortcuts — just pure, fresh and trusted homemade goodness.
        </p>

        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          {[
            { icon: Heart, title: "With Love", text: "Handmade in small batches." },
            { icon: Leaf, title: "Pure Ingredients", text: "Fresh, quality-first." },
            { icon: Sparkles, title: "Customised", text: "Personalised for you." },
          ].map((f) => (
            <div key={f.title} className="rounded-2xl border border-brand-line bg-white p-6">
              <f.icon className="mx-auto h-8 w-8 text-brand" />
              <h3 className="mt-3 font-heading text-xl text-brand-dark">{f.title}</h3>
              <p className="mt-1 text-sm text-brand-muted">{f.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <WhatsAppButton testId="about-whatsapp-btn" message={`Hi ${settings.business_name || "Taanya Homefoods"}, I'd love to know more about your homemade products.`} />
        </div>
      </div>
    </div>
  );
}
